import PropTypes from 'prop-types';
import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap";
import { Link } from "react-router-dom";



import "chartist/dist/scss/chartist.scss";

//i18n
import { withTranslation } from "react-i18next";

const Dashboard = props => {
  const [menu, setMenu] = useState(false);
  const toggle = () => {
    setMenu(!menu);
  };
  document.title = "Presupuestos | IPG";
  return (
    <React.Fragment>
      <div className="page-content ">
        <Container fluid>
          <div className="page-title-box pb-0">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Presupuesto</h6>
                <ol className="breadcrumb ">
                  {/* <li className="breadcrumb-item active">Welcome to Veltrix Dashboard</li> */}
                </ol>
              </Col>
            </Row>
          </div>
      
        </Container>
      </div>

    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any
};

export default withTranslation()(Dashboard);
